import React from 'react';

import { WarningIcon } from '@assets/icons';
import { Icon } from '@components/Icon';

import { ErrorMessageWrapper, ErrorMessageLabel } from './ErrorMessageStyle';

export { ErrorMessageWrapper };
interface ErrorMessageProps {
  icon?: React.ComponentType<
    React.PropsWithChildren<
      React.PropsWithChildren<
        React.PropsWithChildren<
          React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
        >
      >
    >
  >;
  message?: string;
  showIcon?: boolean;
}

const ErrorMessage = ({
  message,
  icon = WarningIcon,
  showIcon = true,
}: ErrorMessageProps) => {
  return (
    <ErrorMessageWrapper showIcon={showIcon}>
      <Icon icon={icon} />
      <ErrorMessageLabel>{message}</ErrorMessageLabel>
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;
